export default "__VITE_ASSET__DVwE6oSd__"